import { Component, Inject } from '@angular/core';
import { MessageService } from '../../services/message.service';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})

export class MessagesComponent {

  constructor(
    public messageService: MessageService,
    @Inject(MAT_SNACK_BAR_DATA) public data: string
  ) { }

}
